<template>
  <modal :show="visible" @close="visible = false" modalClasses="modal-xxl">
    <div slot="header">
      <h3 v-if="type == 'IN'">Thêm sản phẩm không qua sản xuất</h3>
      <h3 v-if="type == 'OUT'">Xuất phế</h3>
    </div>
    <block ref="bmdal" style="min-height: 400px; overflow-y: auto;">
      <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
        <form role="form" @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-6">
              <base-select
                label="Sản phẩm"
                class="w-100"
                :disabled="true"
                @change="productChange"
                v-model="product"
                :ajaxData="getProduct"
                :error="!product || !product.id"
              >
                <template v-slot:selected="{ item }">
                  <div>{{ item.code }} - {{ item.name }}</div>
                </template>
                <template v-slot:body="{ item }">
                  <div>
                    <strong>{{ item.code }}</strong> <br />
                    <span>{{ item.name }}</span>
                  </div>
                </template>
              </base-select>
            </div>
            <div class="col-3">
              <base-select
                label="Quy cách"
                v-if="product && product.id"
                v-model="productInfo.productSpecify"
                :options="product.productSpecifys"
                :disabled="true"
                :error="!productInfo.productSpecify || !productInfo.productSpecify.id"
              >
                <template v-slot:selected="{ item }">
                  <div>
                    <span>{{ item.id }} - </span>
                    {{ item.name }} mm
                    <span v-if="item.color && item.color.id"> - {{ item.color.label }} </span>
                  </div>
                </template>
                <template v-slot:body="{ item }">
                  <div>
                    <span>{{ item.name }} mm</span>
                    <span v-if="item.color && item.color.id"> - {{ item.color.label }} - {{ item.unit }} </span>
                  </div>
                </template>
              </base-select>
            </div>
            <div class="col-3">
              <base-input :disabled="true" label="Đơn vị tính" v-model="productInfo.productSpecify.unit"> </base-input>
            </div>
            <div class="col-3">
              <base-input label="Mã màu 1" :disabled="isFromInfo" v-model="productInfo.colorCode1"> </base-input>
            </div>
            <div class="col-3">
              <base-input label="Mã màu 2" :disabled="isFromInfo" v-model="productInfo.colorCode2"> </base-input>
            </div>
            <div class="col-6">
              <base-input label="Tên màu" :disabled="isFromInfo" v-model="productInfo.colorText"> </base-input>
            </div>
            <div class="col-3">
              <base-input label="Chiều dài (cm)" :disabled="isFromInfo" v-model="productInfo.length"> </base-input>
            </div>
            <div class="col-3">
              <base-input label="Định mức" :disabled="isFromInfo" v-model="productInfo.quota"> </base-input>
            </div>
            <div class="col-6">
              <base-input
                :label="`Số lượng ( ${productInfo.productSpecify.unit})`"
                :valid="productInfo.quantity > 0"
                :mask="'number'"
                v-model="productInfo.quantity"
              ></base-input>
            </div>

            <!-- <div class="col-3">
              <base-input style="height: 50px;" label="Tổng số kg / bọc" v-model="productInfo.totalKgWrap"> </base-input>
            </div> -->
          </div>
          <div class="row">
            <div class="col-12">
              <base-select
                label="Diễn giải"
                class="w-100"
                :disabled="isFromInfo"
                @change="reasonChange"
                v-model="reason"
                :ajaxData="getReason"
              >
                <template v-slot:selected="{ item }">
                  <div>{{ item.key }} - {{ item.name }}</div>
                </template>
                <template v-slot:body="{ item }">
                  <div>
                    <strong>{{ item.key }}</strong> <br />
                    <span>{{ item.name }}</span>
                  </div>
                </template>
              </base-select>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-6" v-if="type == 'IN'">
              <div class="form-group" style="overflow: hidden;">
                <label class="form-control-label" for="">Vị trí lưu kho</label>
                <ckeditor
                  :editor="editor"
                  v-model="productInfo.position"
                  @ready="onReady"
                  :config="editorConfig"
                ></ckeditor>
              </div>
            </div>
            <div class="col-6" :class="{ 'col-12': type == 'OUT' }">
              <div class="form-group" style="overflow: hidden;">
                <label class="form-control-label" for="">Ghi chú/nguyên nhân</label>
                <ckeditor
                  :editor="editor"
                  v-model="productInfo.description"
                  @ready="onReady"
                  :config="editorConfig"
                ></ckeditor>
              </div>
            </div>
          </div>
        </form>
        <hr />
        <button type="button" @click="handleClose" class="btn btn-secondary">
          Đóng
        </button>
        <button type="submit" @click="doSave(0)" class="btn btn-dark">
          Lưu đóng (F4)
        </button>
      </ValidationObserver>
    </block>
    <event @doSave="doSave(0)" @doCancel="handleClose"></event>
  </modal>
</template>
<script>
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { productService } from '@/_services';
import { type } from 'jquery';

export default {
  props: {},
  components: {
    ckeditor: CKEditor.component
  },
  data() {
    return {
      visible: false,
      type: 'IN',
      isFromInfo: false, // mở lên từ danh sách sản phẩm đã sản xuất
      productInfo: {
        id: 0,
        color: {},
        productSpecify: {},
        unit: '',
        product: {},
        colorCode1: '',
        colorCode2: '',
        colorText: '',
        length: 0,
        quota: 0,
        quantity: 0,
        totalKgWrap: 0,
        position: '',
        description: ''
      },
      reason: {},
      product: {},
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          'heading',
          '|',
          'fontSize',
          'fontFamily',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'bold',
          'italic',
          'link',
          'underline',
          'strikethrough',
          '|',
          'alignment',
          'bulletedList',
          'numberedList',
          'blockQuote',
          '|',
          'indent',
          'outdent',
          'link',
          'insertTable',
          'tableColumn',
          'tableRow',
          'mergeTableCells'
        ]
      }
    };
  },
  methods: {
    setDataFromUnit(product, Specify, type = 'IN') {
      this.isFromInfo = false;
      this.productInfo = {
        id: null,
        color: Specify.color,
        productSpecify: Specify,
        unit: Specify.unit,
        product: {
          id: product.id,
          code: product.code,
          name: product.name,
          type: product.type
        },
        colorCode1: '',
        colorCode2: '',
        colorText: '',
        length: 0,
        quota: 0,
        quantity: 0,
        totalKgWrap: 0,
        position: '',
        description: '',
        reasonId: -1
      };
      this.type = type;
      this.product = product;
      let i = this.checkProductInfoExits(product.productInfos, this.productInfo);
      if (i >= 0) {
        var self = this;
        this.$swal({
          title: 'Sản phẩm này đã tồn tại trong kho',
          text: 'Bạn có muốn tiếp tục không ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Không',
          reverseButtons: true
        }).then(function(result) {
          if (!result.value) {
            self.handleClose();
          }
        });
      }
    },
    setDataFromProductInfo(product, productInfo, type = 'IN') {
      this.isFromInfo = true;
      this.productInfo = Object.assign({}, productInfo);
      this.productInfo.quantity = 0;
      this.productInfo.description = '';
      this.reason = productInfo.reason;
      this.type = type;
      this.product = product;
    },
    checkProductInfoExits(list, productInfo) {
      if (!productInfo.color || !productInfo.productSpecify || !list || list.length == 0) {
        return -1;
      }
      let index = list.findIndex(item => {
        return (
          item.color.id == productInfo.color.id &&
          item.unit == productInfo.unit &&
          item.productSpecify.id == productInfo.productSpecify.id &&
          item.colorCode1 == productInfo.colorCode1 &&
          item.length == productInfo.length
        );
      });
      return index;
    },
    doSave: function(type) {
      var self = this;
      if (!this.visible) return;
      if (this.productInfo.quantity <= 0) {
        this.$alertify.error('Số lượng phải lớn hơn 0');
        return;
      }
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        this.$refs.bmdal.block();
        if (this.type == 'IN') {
          productService
            .saveInInfoOfProduct(self.productInfo)
            .then(res => {
              this.$emit('reloadProductInfo');
              this.$alertify.success(res.message, {
                duration: 4000
              });
            })
            .catch(err => {
              if (err.data) {
                err.data.forEach(element => {
                  let errObj = {};
                  errObj[element.context.key] = [element.message];
                  self.$refs.csInfo.setErrors(errObj);
                });
              }
            })
            .finally(() => {
              if (type == 0) {
                self.visible = false;
              }
              this.$refs.bmdal.unBlock();
            });
        } else {
          productService
            .saveOutInfoOfProduct(self.productInfo)
            .then(res => {
              this.$emit('reloadProductInfo');
              this.$alertify.success(res.message, {
                duration: 4000
              });
            })
            .catch(err => {
              if (err.data) {
                err.data.forEach(element => {
                  let errObj = {};
                  errObj[element.context.key] = [element.message];
                  self.$refs.csInfo.setErrors(errObj);
                });
              }
            })
            .finally(() => {
              if (type == 0) {
                self.visible = false;
              }
              this.$refs.bmdal.unBlock();
            });
        }
      });
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    handleClose() {
      this.visible = false;
    },
    getProduct(keyword, cb) {
      productService.findAll({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    getReason(keyword, cb) {
      productService.findReason({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    reasonChange(row) {
      this.productInfo.reasonId = row.id;
    },
    productChange(row) {
      this.productInfo.product = row;
      this.productInfo.productSpecify = {};
    }
  }
};
</script>
